export default "__VITE_ASSET__CmigXJRH__"